export default __webpack_public_path__ + "static/media/mamut_background_m1.02e93a92.jpg";